import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import LoadingScreen from "../../components/LoadingScreen";
import useStore from "../../store/useStore";

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const vendorId = useStore((state) => state.vendorId);

  useEffect(() => {
    if (currentUser && !vendorId) {
      useStore.getState().setSessionContext({
        vendorId: currentUser.uid,
        userRole: "vendor",
      });
    }
  }, [currentUser, vendorId]);

  if (loading) {
    return <LoadingScreen message="Authenticating..." />;
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
